export const ADDRESS_DETAILS_MAX_LENGTH = 10;
export const ADDRESS_MAX_LENGTH = 300;
export const ADDRESS_COMMENT_MAX_LENGTH = 1000;
